import request from '../../utils/request';

export interface ControlTowerQuery {
  companyId?: string;
  carrierId?: string;
  refresh?: boolean;
}

export interface TollGateData {
  name: string;
  threshold: string;
  day: string;
  beforeThreshold: number;
  afterThreshold: number;
  attemptBeforeThreshold?: number;
  attemptAfterThreshold?: number;
  restStillTime: number;
  restTooLate: number;
}

export type ControlTowerData = Record<string, TollGateData[]>;

export interface CutoffTimes {
  id: number;
  locationId: string;
  locationName: string;
  deliveryAreaName: string;
  sortedAtCutoffHours: number;
  sortedAtCutoffMinutes: number;
  sortedAtDaysDiff: number;
  firstCarrierScanAtCutoffHours: number;
  firstCarrierScanAtCutoffMinutes: number;
  firstCarrierScanAtDaysDiff: number;
  firstOutForDeliveryAtCutoffHours: number;
  firstOutForDeliveryAtCutoffMinutes: number;
  firstOutForDeliveryAtDaysDiff: number;
  completedAtCutoffHours: number;
  completedAtCutoffMinutes: number;
  completedAtDaysDiff: number;
}

export type CutoffTimesData = CutoffTimes[];

export const useApi = () => {
  const getControlTowerData = async (
    params?: ControlTowerQuery,
  ): Promise<{ error?: string; data?: ControlTowerData }> => {
    const { error, response } = await request('/control-tower', { params });

    return { error: error?.message || error?.response, data: response };
  };
  const getCutoffValues = async (params?: ControlTowerQuery): Promise<{ error?: string; data?: CutoffTimesData }> => {
    const { error, response } = await request('/control-tower/cutoff-times', { params });

    return { error: error?.message || error?.response, data: response };
  };

  return { getControlTowerData, getCutoffValues };
};
